import { render, staticRenderFns } from "./listBaseTable.vue?vue&type=template&id=427f63e9&scoped=true&"
import script from "./listBaseTable.vue?vue&type=script&lang=js&"
export * from "./listBaseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f63e9",
  null
  
)

export default component.exports